import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import "./HrManagementFooter.scss";

const HrManagementFooter = () => {
  return (
    <>
        <div className="footer-section">
        <Container>
          <Row>
            <Col lg={12}>
              <p className="text-center mb-0">Copyright © 2025. Hexlog Infotech Pvt. Ltd. All Rights Reserved.</p>
            </Col>
          </Row>
        </Container>
       </div>
    </>
  )
}

export default HrManagementFooter;